import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_BLUE, TSS_RED, TSS_GREEN } from 'tss-core-lib-common';

var styles = void 0;

var VersionStatusLabel = function VersionStatusLabel(_ref) {
  var status = _ref.status,
      active = _ref.active,
      inactive = _ref.inactive;
  return React.createElement(
    'div',
    {
      className: css(styles.container, active && styles.activeContainer, inactive && styles.inactiveContainer)
    },
    React.createElement(
      'span',
      null,
      '' + status
    )
  );
};

VersionStatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
  active: PropTypes.bool,
  inactive: PropTypes.bool
};

VersionStatusLabel.defaultProps = {
  active: false,
  inactive: false
};

styles = StyleSheet.create({
  container: {
    color: TSS_BLUE(),
    fontWeight: 400,
    fontSize: '1.6rem'
  },

  activeContainer: {
    color: TSS_GREEN()
  },

  inactiveContainer: {
    color: TSS_RED()
  }
});

export default VersionStatusLabel;